export default __webpack_public_path__ + "static/img/ig_contact_2.52d8417.png";